import React, { useEffect } from 'react';
import { Input, Form, Tabs, Card, Button } from 'antd';
import { getFirestore, doc, updateDoc } from "firebase/firestore";
import { showSuccessNotification, showErrorNotification } from '../../utils/notifications';

const { TabPane } = Tabs;

const EditProduct = ({ product }) => {
    const [form] = Form.useForm();
    const db = getFirestore();

    useEffect(() => {
        if (product) {
            form.setFieldsValue(product);
        }
    }, [product, form]);

    const handleUpdate = async (values) => {
        try {
            const productRef = doc(db, "Products", product.id);
            await updateDoc(productRef, values);
            showSuccessNotification("Product details updated successfully");
        } catch (error) {
            console.error("Error updating product:", error);
            showErrorNotification("Error updating product");
        }
    };

    if (!product) {
        return null;
    }

    return (
        <Card
            title="Product Descriptions"
            style={{ marginTop: 16, marginBottom: 16 }}
        >
            <Form
                form={form}
                layout="vertical"
                initialValues={product}
                onFinish={handleUpdate}
            >
                <Tabs defaultActiveKey="en">
                    <TabPane tab="EN" key="en">
                        <Form.Item name="descriptionEn" label="Description EN">
                            <Input.TextArea autoSize={{ minRows: 3, maxRows: 6 }} placeholder="Insert description..." />
                        </Form.Item>
                    </TabPane>
                    <TabPane tab="IT" key="it">
                        <Form.Item name="descriptionIt" label="Descrizione IT">
                            <Input.TextArea autoSize={{ minRows: 3, maxRows: 6 }} placeholder="Insert description..." />
                        </Form.Item>
                    </TabPane>
                    <TabPane tab="DE" key="de">
                        <Form.Item name="descriptionDe" label="Description DE">
                            <Input.TextArea autoSize={{ minRows: 3, maxRows: 6 }} placeholder="Insert description..." />
                        </Form.Item>
                    </TabPane>
                    <TabPane tab="ES" key="es">
                        <Form.Item name="descriptionEs" label="Description ES">
                            <Input.TextArea autoSize={{ minRows: 3, maxRows: 6 }} placeholder="Insert description..." />
                        </Form.Item>
                    </TabPane>
                    <TabPane tab="FR" key="fr">
                        <Form.Item name="descriptionFr" label="Descrizione FR">
                            <Input.TextArea autoSize={{ minRows: 3, maxRows: 6 }} placeholder="Insert description..." />
                        </Form.Item>
                    </TabPane>
                </Tabs>
                <Form.Item>
                    <Button type="primary" htmlType="submit">
                        Save Changes
                    </Button>
                </Form.Item>
            </Form>
        </Card>
    );
};

export default EditProduct;